import { useMessageComposer } from './useMessageComposer';
import { useStateStore } from '../../../store';
const editingAuditStateStateSelector = (state) => state;
export const useMessageComposerHasSendableData = () => {
    const messageComposer = useMessageComposer();
    useStateStore(messageComposer.editingAuditState, editingAuditStateStateSelector);
    return messageComposer.hasSendableData;
};
